/**
 * Onde a sessão do painel mora entre um F5 e outro.
 *
 * <h3>`sessionStorage`, e não `localStorage`</h3>
 * A diferença é uma aba fechada. `localStorage` sobrevive ao navegador inteiro, e num
 * computador compartilhado — que é o computador de quase todo galpão — isso significa a
 * próxima pessoa abrindo o painel já autenticada como a anterior.
 *
 * <h3>Nem `sessionStorage` é o lugar certo, e isso está declarado</h3>
 * Token acessível a JavaScript é token que um XSS carrega embora. O certo é cookie
 * `HttpOnly` + `SameSite`, e isso exige mudar o servidor: hoje ele emite Bearer, que o
 * aplicativo do operador também consome. Fica como dívida nomeada, e não como esquecimento.
 */

export interface Sessao {
  accessToken: string;
  refreshToken: string;
  userId: string;
  nome: string;
}

const CHAVE = 'confira.sessao';

export function lerSessao(): Sessao | null {
  try {
    const cru = sessionStorage.getItem(CHAVE);
    return cru ? (JSON.parse(cru) as Sessao) : null;
  } catch {
    // Navegador com armazenamento bloqueado. Sem sessão é melhor do que sem painel.
    return null;
  }
}

export function gravarSessao(s: Sessao): void {
  try {
    sessionStorage.setItem(CHAVE, JSON.stringify(s));
  } catch {
    // Ignorado de propósito: a sessão continua valendo em memória nesta aba.
  }
}

export function limparSessao(): void {
  try {
    sessionStorage.removeItem(CHAVE);
  } catch {
    // idem
  }
}
